import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db';

/**
 * Hook to get sync status across all entities
 * Returns counts of pending and failed sync items
 */
export function useSyncStatus() {
    // Get items pending sync from sync_queue  
    const pendingItems = useLiveQuery(async () => {
        return db.sync_queue.count();
    }, []) || 0;

    // Get failed items from each entity table
    const failedItems = useLiveQuery(async () => {
        const results = [];

        // Check each entity table for failed items
        const tables = [
            { table: db.patients, name: 'patient' },
            { table: db.appointments, name: 'appointment' },
            { table: db.facility_charges, name: 'facility_charge' },
            { table: db.appointment_notes, name: 'note' },
            { table: db.fee_agreements, name: 'fee_agreement' },
            { table: db.form_assessments, name: 'form_assessment' }
        ];


        for (const { table, name } of tables) {
            try {
                const failed = await table
                    .filter(item => item.sync_status === 'failed')
                    .toArray();

                for (const item of failed) {
                    results.push({
                        entity: name,
                        id: item.id,
                        error: item.sync_error || 'Unknown error'
                    });
                }
            } catch {
                // Table might not exist or filter fails
            }
        }

        return results;
    }, []) || [];

    return {
        pendingCount: pendingItems,
        failedCount: failedItems.length,
        failedItems,
        hasIssues: pendingItems > 0 || failedItems.length > 0
    };
}
